import {combineReducers} from 'redux';
import AuthReducer from './AuthReducer';
import PatientInfoReducer from './PatientInfoReducer';
import OfflineReducer from './OfflineReducer';
import {reducer as reduxForm} from 'redux-form';

const appReducer = combineReducers({
  form: reduxForm,
  auth: AuthReducer,
  patientInfo: PatientInfoReducer,
  offline: OfflineReducer,
});

// Meant for any global state changes (if any)
const rootReducer = (state: any, action: any): any => {
  return appReducer(state, action);
};

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;